/**
 * Generated bundle index. Do not edit.
 */

export {Slider,SliderModule} from './public_api';

export {SliderComponent as ɵa} from './src/app/slider/slider.component';